import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseUrl, api_service_path } from "./utils"

export const certificatesAction = createApi({
    reducerPath: "certificate",
    baseQuery: fetchBaseQuery({
        baseUrl: `${baseUrl}/${api_service_path.certificate}`,
        prepareHeaders: (headers) => {
            const current_user = localStorage.getItem("current_user") ? JSON.parse(localStorage.getItem("current_user")) : null
            if (current_user?.token) {
                headers.set(
                    "Authorization",
                    `Bearer ${current_user.token}`
                )
            }
            return headers
        }
    }),
    tagTypes: ["certificates"],
    endpoints: (builder) => ({
        createBonofideCertificate: builder.mutation({
            query: (data) => ({
                url: "/bonofide-certificates",
                method: "POST",
                body: data,
                responseHandler: (res) => res.blob()
            })
        }),
        createSchoolLeavingCertificate: builder.mutation({
            query: (data) => ({
                url: "/school-leaving-certificate",
                method: "POST",
                body: data,
                responseHandler: (res) => res.blob()
            })
        }),
        createCharacterCertificate: builder.mutation({
            query: (data) => ({
                url: "/character-certificate",
                method: "POST",
                body: data,
                responseHandler: (res) => res.blob()
            })
        }),
        createSportCertificate: builder.mutation({
            query: (data) => ({
                url: "/sports-certificate",
                method: "POST",
                body: data,
                responseHandler: (res) => res.blob()
            })
        }),
        createProvisionalCertificate: builder.mutation({
            query: (data) => ({
                url: "/provisional-certificate",
                method: "POST",
                body: data,
                responseHandler: (res) => res.blob()
            })
        }),
        createPromotionCertificate: builder.mutation({
            query: (data) => ({
                url: "/promotion-certificate",
                method: "POST",
                body: data,
                responseHandler: (res) => res.blob()
            })
        }),
        createTransferCertificate: builder.mutation({
            query: (data) => ({
                url: "/transfer-certificate",
                method: "POST",
                body: data,
                responseHandler: (res) => res.blob()
            })
        }),
        marksheetTemplateAction:builder.query({
            query:()=> ({
                url:"/all-marksheet-template",
                method:"GET"
            })
        }),
        downloadMarksheet:builder.mutation({
            query:(data)=>({
                url:"/student-marksheet",
                method:'POST',
                body:data,
                responseHandler:(response)=> {
                    if(response.ok){
                        return response.blob()
                    }else{
                        return response.json()
                    }
                }
            })
        })
    })
})

export const {
    useCreateBonofideCertificateMutation,
    useCreateSchoolLeavingCertificateMutation,
    useCreateCharacterCertificateMutation,
    useCreateSportCertificateMutation,
    useCreateProvisionalCertificateMutation,
    useCreatePromotionCertificateMutation,
    useCreateTransferCertificateMutation,

    useLazyMarksheetTemplateActionQuery,

    useDownloadMarksheetMutation
} = certificatesAction